import { useState } from "react";
import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import CopyLink from "components/icons/social/CopyLink";
import Text from "components/base/Text";
import Trans from "components/base/Trans";
import RichText from "components/base/RichText";
import { motion } from "framer-motion";
import { viewAppearDefault } from "utils/motion";

const MotionAccordionButton = motion(AccordionButton);
const MotionAccordionItem = motion(AccordionItem);

const FaqElement = ({
  question,
  answer,
  uid,
  onClick,
  onLinkClick,
  local,
  ...props
}) => {
  const [hovering, setHovering] = useState(false);
  return (
    <MotionAccordionItem
      {...props}
      variants={viewAppearDefault}
      id={uid}
      py={["xs", null, "md"]}
      bg="charcoal.800"
      borderRadius="none"
      borderColor="gray.800"
      onClick={onClick ? () => onClick(uid) : null}
    >
      <h3 style={{ margin: 0 }}>
        <MotionAccordionButton
          _focus={{ boxShadow: "none" }}
          alignItems="center"
          display={["flex", null, "none"]}
        >
          {onLinkClick ? (
            <CopyLink
              width="32px"
              height="32px"
              color="white"
              mr="sm"
              onClick={() => onLinkClick(uid)}
            />
          ) : null}
          <Text textAlign="left" flex={1} color="white" type="p_lg" as="span">
            {local ? <Trans id={question} /> : question}
          </Text>
          <AccordionIcon
            color="gray.300"
            fontSize="3xl"
            ml={4}
            alignSelf="top"
          />
        </MotionAccordionButton>
      </h3>
      <h3 style={{ margin: 0 }}>
        <MotionAccordionButton
          _focus={{ boxShadow: "none" }}
          alignItems="center"
          onHoverStart={() => setHovering(true)}
          onHoverEnd={() => setHovering(false)}
          display={["none", null, "flex"]}
        >
          {onLinkClick ? (
            <CopyLink
              width="32px"
              height="32px"
              color="white"
              opacity={hovering ? 0.2 : 0}
              mr="sm"
              onClick={() => onLinkClick(uid)}
            />
          ) : null}
          <Text textAlign="left" flex={1} color="white" type="p_lg" as="span">
            {local ? <Trans id={question} /> : question}
          </Text>
          <AccordionIcon
            color="gray.300"
            fontSize="3xl"
            ml={4}
            alignSelf="top"
          />
        </MotionAccordionButton>
      </h3>
      <AccordionPanel pb={["xs", null, "md"]}>
        <Text textAlign="left" color="white" opacity={0.7} type="p_md" as="div">
          <RichText content={answer} />
        </Text>
      </AccordionPanel>
    </MotionAccordionItem>
  );
};

export default FaqElement;
